const CHUNK_RELOAD_STORAGE_KEY = 'dms-ark:chunk-load-reload-key';

const CHUNK_LOAD_ERROR_PATTERNS = [
  /Failed to fetch dynamically imported module/i,
  /Importing a module script failed/i,
  /error loading dynamically imported module/i,
  /ChunkLoadError/i,
  /Loading chunk \d+ failed/i,
  /Expected a JavaScript-or-Wasm module script/i
];

const getCurrentBuildKey = (): string => {
  const entryScript = document.querySelector<HTMLScriptElement>('script[type="module"][src]');
  return entryScript?.src ?? window.location.href;
};

const shouldHandleChunkLoadError = (error: unknown): boolean => {
  if (!error) return false;

  if (error instanceof Error) {
    return CHUNK_LOAD_ERROR_PATTERNS.some(
      (pattern) => pattern.test(error.message) || pattern.test(error.name)
    );
  }

  return CHUNK_LOAD_ERROR_PATTERNS.some((pattern) => pattern.test(String(error)));
};

const reloadOnceForCurrentBuild = () => {
  const buildKey = getCurrentBuildKey();

  try {
    const lastReloadKey = window.sessionStorage.getItem(CHUNK_RELOAD_STORAGE_KEY);

    if (lastReloadKey === buildKey) {
      return;
    }

    window.sessionStorage.setItem(CHUNK_RELOAD_STORAGE_KEY, buildKey);
  } catch {
    return;
  }

  window.location.reload();
};

export const installChunkLoadErrorReload = () => {
  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault();
    reloadOnceForCurrentBuild();
  });

  window.addEventListener(
    'error',
    (event) => {
      if (shouldHandleChunkLoadError(event.error) || shouldHandleChunkLoadError(event.message)) {
        event.preventDefault();
        reloadOnceForCurrentBuild();
      }
    },
    true
  );

  window.addEventListener('unhandledrejection', (event) => {
    if (shouldHandleChunkLoadError(event.reason)) {
      event.preventDefault();
      reloadOnceForCurrentBuild();
    }
  });
};
